import { useMemo } from 'react';
import { getContent, type AppContent, type Locale } from '../content';

export function useContent(locale: Locale = 'en'): AppContent {
  // For now this just resolves synchronously; in the future this could fetch from a CMS
  return useMemo(() => getContent(locale), [locale]);
}
